module.exports = __webpack_public_path__ + "static/scale-model-of-lane-county-history-museum-in-eugene-oregon-acdda9cec615caf59ec07532d34f4e7f.png";